import { render, staticRenderFns } from "./OnlineMoneyTransfers.vue?vue&type=template&id=3ab520af&scoped=true&"
import script from "./OnlineMoneyTransfers.vue?vue&type=script&lang=js&"
export * from "./OnlineMoneyTransfers.vue?vue&type=script&lang=js&"
import style0 from "./OnlineMoneyTransfers.vue?vue&type=style&index=0&id=3ab520af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab520af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow,VTextField})
